import { DIALOG_OPEN, DIALOG_CLOSE } from '../actionConstants';
import dialogVariants from './dialogVariations';
import { Dialog } from './dialogTypes';
import { CustomAction } from '../../generalTypes';
import { Action } from 'redux';

export const actionOpenSeriesGallery = (
  options: Dialog
): CustomAction<{ options: Dialog; dialog: any }> => ({
  type: DIALOG_OPEN,
  payload: {
    dialog: dialogVariants.SERIES_GALLERY,
    options,
  },
});

export const closeSeriesGallery = (): CustomAction<{ dialog: any }> => ({
  type: DIALOG_CLOSE,
  payload: {
    dialog: dialogVariants.SERIES_GALLERY,
  },
});

export const openDeeplinkChoice = (
  options: Dialog
): CustomAction<{ options: Dialog; dialog: any }> => ({
  type: DIALOG_OPEN,
  payload: {
    dialog: dialogVariants.DEEPLINK_CHOICE,
    options,
  },
});

export const openPacMissing = (
  options: Dialog
): CustomAction<{ options: Dialog; dialog: any }> => ({
  type: DIALOG_OPEN,
  payload: {
    dialog: dialogVariants.PAC_MISSING,
    options,
  },
});

export const openIpexGalleryWarning = (
  options: Dialog
): CustomAction<{ options: Dialog; dialog: any }> => ({
  type: DIALOG_OPEN,
  payload: {
    dialog: dialogVariants.IPEX_GALLERY_WARNING,
    options,
  },
});

export const openAmeliorationDialog = (
  options: Dialog
): CustomAction<{ options: Dialog; dialog: any }> => ({
  type: DIALOG_OPEN,
  payload: {
    dialog: dialogVariants.AMELIORATION_DIALOG,
    options,
  },
});

export const actionCloseDialog = (): Action => ({
  type: DIALOG_CLOSE,
});
